import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import "bootstrap/dist/css/bootstrap.css";
import "./login.scss";
import UsersService from "services/http/users-service";
import jwtWorker from 'utils/jwt-worker';
import logo_ooredoo from "assets/img/logo_ooredoo.png";
import social_media from "assets/img/social_media.svg";
import Utils, { BASE_ROUTES } from "utils";
import { CustomButton, Input, Alert } from 'components/shared';
import { Link } from "react-router-dom";
import { Footer } from 'components/layout';

export const Login = () => {
    const [credentials, setCredentials] = useState({ username: null, password: null });
    const [loginState, setLoginState] = useState({ loading: false, token: null, error: null });
    const [showPassword, setShowPassword] = useState(false);
    const [loading, setLoading] = useState(false);
    const { handleSubmit } = useForm();

    function loginAttempt() {
        setLoading(true);
        setLoginState({ ...loginState, loading: true, error: null });
        UsersService.login(credentials).then(result => {
            onLoginSuccess(result);
        }, failure => {
            onLoginFailed(failure);
        });
    }

    //on success case
    const onLoginSuccess = (result) => {
        Promise.resolve(jwtWorker.setTokenInStorage(result.authorization)).then(() => {
            window.location.reload(false);
        });
    }

    //on failure login
    const onLoginFailed = (failure) => {
        setLoading(false);
        setLoginState({ ...loginState, loading: false, error: failure })
    }

    return (
        <div>
            <div className="container">
                <div className="row py-5 mt-4">
                    {/* <!-- Login Form --> */}
                    <section className="h-200 col-md-5 ml-auto">
                        <div className="container h-100">
                            <div className="card-wrapper w-100">
                                <div className="brand text-center">
                                    <br />
                                    <img src={logo_ooredoo} alt="Ooredoo" width={"60%"}/><br /><br />
                                </div>
                                <br />
                                <div className="card">
                                    <div className="card-body">
                                        <h4 className="card-title text-center">Login</h4>
                                        <form onSubmit={handleSubmit(loginAttempt)} className="my-login-validation">
                                            <Input
                                                id="username"
                                                name="username"
                                                type="text"
                                                required
                                                placeholder="Username"
                                                icon="pi pi-user"
                                                parentClass="my-3"
                                                value={credentials.username}
                                                onChange={(e) => { e.preventDefault(); setCredentials({ ...credentials, username: e.target.value }) }} />
                                            <Input
                                                id="password"
                                                name="Password"
                                                required
                                                type={showPassword ? "text" : "password"}
                                                placeholder='Password'
                                                icon="pi pi-lock"
                                                parentClass="mt-3 mb-2"
                                                onChange={e => { setCredentials({ ...credentials, password: e.target.value }) }}
                                                value={credentials.password} 
                                            />

                                            <small className="w-100 float-right text-right mb-3">
                                                <Link to={BASE_ROUTES.FORGOT_PASSWORD}>Forgot password?</Link>
                                            </small>

                                            <CustomButton
                                                type="submit"
                                                label={Utils.labelTemplate(<><i className="bi bi-check-circle" /> Submit</>, loading, "Logging in...")}
                                                className="btn btn-primary btn-block my-3"
                                            />
                                            <div className="text-center form-bottom">
                                                {loginState.error && <Alert type="danger" icon="bi bi-x-circle" content={loginState.error} flex iconSize="15px" />}
                                            </div>
                                        </form>
                                    </div>
                                </div>
                               <Footer />
                            </div>
                        </div>
                    </section>

                    <div className="col-md-5 pr-lg- mb-md-0 mr-auto ml-3 mt-5">
                        <img src={social_media} alt="img" className="img-fluid mb-3 d-none d-md-block" />
                        <h1>Sign in</h1>
                        <p class=" text-muted mb-0 sign-label">Welcome to the login page, please sign in to continue.</p>
                        <p class="text-muted">Made By <a href="mailto:DigitalTechnologyGroup@ooredoo.dz" class="text-muted">
                            <u>Ooredoo Digital Development Team</u></a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );

}